/**
 * @module Hero Product Cards Redesign
 */
import { useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import DynamicButton from 'ui/components/Buttons/DynamicButton';
import PropTypes from 'prop-types';
import { trackEvent } from 'ui/js/helpers/tracking';
import styles from './styles/HeroProductCardsRedesign.module.css';
import setHtml from 'ui/js/utils/setHtml';
import Cards from '../ProductCards/cards';
import { useMonarch } from '@redventures/cohesion-utils-react';

const position = 'HERO PRODUCT CARDS REDESIGN';

/**
 * @function HeroProductCardsRedesign
 * @description
 */
const HeroProductCardsRedesign = ( { ...props } ) => {
  const {
    className = '',
    assetName,
    heading,
    subheading,
    backgroundImage,
    hasCta,
    hasSecondaryCta,
    customStyles,
  } = props;

  const { ref, entry } = useInView({
    threshold: 1,
    triggerOnce: true
  });

  const monarchDecision = useMonarch();
  // I hate this but these updates need to go out in like 30 minutes
  const isDoubleDouble = useMemo(() => JSON.stringify(monarchDecision).includes("Double Double"), [monarchDecision]);

  useEffect( () => {
    if ( entry?.isIntersecting === true ) {
      const data = {
        elementType: 'SECTION',
        name: assetName,
        text: `${ position } - HEADING VIEWED`
      };
      trackEvent( { action: 'elementViewed', data, event: {} } );
    }
  }, [ entry, assetName ] );

  return (
    <section className={ `component ${ styles.component } ${ customStyles?.component || '' } ${ styles.component__fiveCards } ${isDoubleDouble ? styles.component__doubleDouble : ''} ${ className }` }>
      <div className={ styles.component__layout }>
        <div className="g-row">
          <h2 ref={ ref } className={ `${ styles.component__heading } ${ customStyles && customStyles?.component__heading }` }>{ <span { ...setHtml( heading ) } /> }</h2>
          { subheading && ( <h5 className={ `${ styles.component__subheading } ${ customStyles && customStyles?.component__subheading }` }>{ subheading }</h5> ) }
        </div>
      </div>

      <div 
        className={ styles.component__backgroundImage }
        style={{
          backgroundImage: `url(${process.env.imagePath}/img${ backgroundImage })`
        }}
      />

      <div className={ `${ styles.component__ctaContainer }` }>
        { hasCta && (
          <DynamicButton className={ `btn ${ styles.component__btn } ${ customStyles?.component__btn || '' }` } type="cart" />
        ) }
        { hasSecondaryCta && (
          <DynamicButton className={ `btn ${ styles.component__btn }` } type="phone" theme="white"></DynamicButton>
        ) }
      </div>

      <Cards {...props} position={position} isDoubleDouble={isDoubleDouble} />
    </section>
  );
};

HeroProductCardsRedesign.propTypes = {
  assetName: PropTypes.string,
  heading: PropTypes.node,
  subheading: PropTypes.node,
  hasCTA: PropTypes.bool,
  hasSecondaryCTA: PropTypes.bool,
  cardsCtaType: PropTypes.string,
  fiber500Copy: PropTypes.string,
  fiberGigCopy: PropTypes.string,
  fiber2GigCopy: PropTypes.string,
  fiber5GigCopy: PropTypes.string,
  fiber7GigCopy: PropTypes.string,
  fiber500Features: PropTypes.array,
  fiberGigFeatures: PropTypes.array,
  fiber2GigFeatures: PropTypes.array,
  fiber5GigFeatures: PropTypes.array,
  fiber7GigFeatures: PropTypes.array
};

export default HeroProductCardsRedesign;
